import { memo } from 'react';
import { Info } from '@betty/moonlight';
import { GamblingForbiddenProps } from './GamblingForbidden.types';

function GamblingForbidden(props: GamblingForbiddenProps) {
  return (
    <Info
      locNS="mkodo"
      title="gamblingForbiddenTitle"
      description="gamblingForbiddenDescription"
      justifyContent="center"
      textAlign="center"
      {...props}
    />
  );
}

export default memo(GamblingForbidden);
